import { IGa4AddToCart, IGa4ReviewOrderSummary, IGa4ViewItem } from "../interfaces/ga4-event.interface";

export class Ga4EventService {
    private fireEvent(event: string, data: any) {
        window.dataLayer = window.dataLayer ?? [];
        window.dataLayer.push({ ecommerce: null });
        window.dataLayer.push({
            event: event,
            ecommerce: data,
        });
    }

    public addToCart(data: IGa4AddToCart) {
        this.fireEvent('con_add_to_cart', data);
    }

    public viewItem(data: IGa4ViewItem) {
        this.fireEvent('con_view_item', data);
    }

    public reviewOrderSummary(data: IGa4ReviewOrderSummary) {
        window.dataLayer = window.dataLayer ?? [];
        window.dataLayer.push({
            event: 'con_review_order_summary',
            payment_type: data.payment_type,
            currency: data.currency,
            value: data.value,
        });
    }
    
    public algoliaAddedToCartObjectIdsAfterSearch() {
        window.dataLayer = window.dataLayer ?? [];
        window.dataLayer.push({
            event: 'algolia_added_to_cart_object_ids_after_search',
        });
    }

    public algoliaAddedToCartObjectIds() {
        window.dataLayer = window.dataLayer ?? [];
        window.dataLayer.push({
            event: 'algolia_added_to_cart_object_ids',
        });
    }
}

export const ga4EventService = new Ga4EventService();
